import { Theme } from './theme'

const DarkTheme: Theme = {
  color: {
    mainBg: '#1c202b',
    mainColor: '#212732',
    subColor: '#2C3340',
    subColor2: '#2A323E',
    accordion1: '#152535',
    subBg: '#203040',
    accordion2: '#253545',
    contentsBg: '#304050',
    tabBg: '#294B72',
    disableBg: '#405060',
    btn: '#506070',
    gray: '#acacac',
    modalTxt: '#141414',
    modalSubTxt: '#5c5c5c',
    modalDarkBg: '#b7b7b7',
    modalSubBg: '#c9c9c9',
    modalSubBg2: '#d5d5d5',
    modalred: '#af1c39',
    modalOrange: '#f56800',
    modalyellow: '#ea8902',
    modalgray: '#929292',
    modalBlue: '#2c346a',
    modalBg: '#ddd',
    themeTxt: '#eee',
    darkTxt: '#99A7B7',
    matchTit1: '#294B72',
    matchTit2: '#172f4b',
    primary: '#2ecadb',
    primaryBg: '#26aab8',
    secondaryBg: '#175da5',
    redBg: '#4d262a',
    blueBg: '#1a445f',
    select: '#257276',
    red: '#DC2323',
    blue: '#369ee2',
    pink: '#FF23FF',
    disableTxt: '#6f777e',
    disableTxt2: '#798897',
    underover: '#aaff00',
    handicap: '#aaff00',
    purple: '#b76fd5',
    yellow: '#ffcc00',
    TP: 'transparent',
    white: '#fff',
    whiteBg: '#f7f7f7'
  },
  border: {
    default: '1px solid #1abc9c',
    secondery: '1px solid #696969',
    line: '1px solid #203040',
    inputLine: '1px solid #acacac',
  },
  font: {
    xxlarge: '2.4rem',
    xlarge: '2rem',
    largeNum: '1.8rem',
    title: '1.6rem',
    large: '1.4rem',
    medium: '1.2rem',
    small: '1rem',
    tiny: '0.8rem',
  },
  fontW: {
    bold: '700',
    medium: '500',
    regular: '400',
  }
}

export default DarkTheme
